import React, { Component, Fragment } from 'react'
import style from './style.popup'

import { LogoDs } from '../app-icon/Icons'
import { ButtonContained } from '../app-button/button'

class Popup extends Component {
  // state = {
  //   opened: true,
  // }

  constructor(props) {
    super(props)
    let popup = window.localStorage.getItem('welcome_popup_shown')

    this.state = {
      opened: popup != 1,
    }
  }

  handleClick = () => {
    window.localStorage.setItem('welcome_popup_shown', 1)

    this.setState({
      opened: false,
    })
  }

  render() {
    const { classes } = this.props

    return (
      <Fragment>
        {this.state.opened ? (
          <div className={classes.popup}>
            <div className={classes.wrapper}>
              <div className={classes.iconWrapper}>
                <div className={classes.icon}>
                  <LogoDs />
                </div>
              </div>
              <div className={classes.content}>
                <h2 className={classes.title}>
                  Добро пожаловать в кабинет ROMI center!
                </h2>
                <p>Вы в нескольких кликах от настройки сквозной аналитики.</p>
                <p>
                  Мы рекомендуем следовать всем шагам настройки и внимательно
                  читать пояснения. Таким образом, вы сможете избежать ошибок
                  при настройке и сервис будет работать корректно.
                </p>
                <p>
                  Также мы подготовили для вас видео настройки, которое вы
                  можете увидеть{' '}
                  <a
                    className={classes.link}
                    href="https://youtu.be/cLF8-zXcZvY"
                    target="_blank"
                  >
                    здесь.
                  </a>
                </p>
                <p>
                  Если у вас возникают сложности при настройке, обязательно
                  пишите нам в чат в кабинете ROMI center, на почту или звоните!
                  Мы постараемся помочь:)
                </p>

                <ButtonContained
                  style={{
                    height: 64,
                    fontSize: 16,
                    width: '400px',
                    padding: 0,
                    fontWeight: 600,
                    margin: '0 auto',
                    marginTop: 32,
                    display: 'block',
                  }}
                  id={'reg_success'}
                  type="submit"
                  color="primary"
                  onClick={() => this.handleClick()}
                  text={'Погнали!'}
                />
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
      </Fragment>
    )
  }
}

export default style(Popup)
